import { render, staticRenderFns } from "./SpecificHeatViz.vue?vue&type=template&id=1a2a4661&scoped=true"
import script from "./SpecificHeatViz.vue?vue&type=script&lang=js"
export * from "./SpecificHeatViz.vue?vue&type=script&lang=js"
import style0 from "./SpecificHeatViz.vue?vue&type=style&index=0&id=1a2a4661&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a4661",
  null
  
)

export default component.exports